<template>
  <div class="dhr-production">
    <h2 class="subtitle">Print the QR-code</h2>
    <div class="dhr-qr">
      <qr-code id="qrPrint" class="print" :text='qrString' :size="240" error-level="L" v-html="QRcode"/>
      <BaseButton size="semi" color="primary" @click.native="print">
        <span class="font-semi">Print QR-code</span>
        <BaseIcon name="print" class="icon white" />
      </BaseButton>
    </div>
  </div>
</template>
<script>
import BaseButton from "@/components/base/Button";
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash";

export default {
  components: {
    InputDash,
    BaseButton,
    BaseIcon
  },
  props: {
    data: Object,
    confirmedDHR: String,
  },
  data() {
    return {
      isIncomplete: true,
      selectedProduction: "",
      isPrinted: false,
      qrString: ''
    };
  },
  mounted() {
    this.renderQR()
  },
  methods: {
    renderQR() {
      var typeDHR = ""
      var that = this

      if(this.data.type == 'Assembly'){
        typeDHR = "LOT"
      } else {
        typeDHR = "BON"
      }

      that.qrString = '{"result": "' + this.confirmedDHR.lotID + '", "name": "' + this.confirmedDHR.lotID+ '", "snummer": "' + this.confirmedDHR.snummer + '", "type": "' + typeDHR + '", "company": "SurgiTec"}'
    },

    print(){
      const qr = document.getElementById('qrPrint').innerHTML;
      const y = window.top.outerHeight / 2 + window.top.screenY - ( 480 / 2);
      const x = window.top.outerWidth / 2 + window.top.screenX - ( 720 / 2);
      const WinPrint = window.open('', '', `left=${x},top=${y},width=720,height=480,toolbar=0,scrollbars=0,status=0`);
      
      WinPrint.document.write('<html><head><title>Print QR</title><style>* { font-family: sans-serif; }</style>');
      WinPrint.document.write('</head><body>');
      WinPrint.document.write(qr);
      WinPrint.document.write('<p>');
      WinPrint.document.write(this.data.type == 'Assembly'? "LOT": "Batch");
      WinPrint.document.write(": " + this.confirmedDHR.lotID);
      WinPrint.document.write(", REF: " + this.data.ref);
      WinPrint.document.write('</p>');
      WinPrint.document.write('</body></html>');

      WinPrint.document.close(); 
      WinPrint.focus()
      WinPrint.print();
      this.isPrinted = true
      this.isIncomplete = false
    },
    comfirmStep() {
      this.$emit("finishedStep", this.selectedProduction);
    },
    doNothing() {
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/inputs";
@import "@/style/components/dhrFormProduction.scss";

.print{
  padding-bottom: 20px;
}
.printQR{
  height: 38px;
}
.font-semi {
  font-weight: 600;
}
</style>;
